mod.modules.define("CurrentListDrawerRight", function(fn) {

	fn.prototype.observables = {
		"list changed": function(newListId) {
			// Update our link to the new list
			this.el.attr("data-auto-list", newListId);
		}
	};

});